import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "@mui/material";
import ErrorModal from "../../utils/ErrorModal";

const OrgCity = () => {
  const [cities, setCities] = useState([]);
  const [name, setName] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
    const [errorModal, setErrorModal] = useState(false)
    const [errorMsg, setErrorMsg] = useState()
  const orgId = JSON.parse(localStorage.getItem("org"));
  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCities = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/city?orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setCities(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddCity = async () => {
    if (!name) return;
    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/city`,
        {
          orgId: orgId,
          username: storedUser.username,
          name: name
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setName("");
      fetchCities();
    } catch (err) {
      setErrorModal(true);
      setErrorMsg(err?.response?.Exception?.data)
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <div className="dashboard-container">
        <h2>Add City</h2>
        <div style={{ display: "flex", columnGap: 25 }}>
          <input
            type="text"
            placeholder="Enter a city name"
            value={name}
            style={{ width: "50%" }}
            onChange={(e) => setName(e.target.value)}
          />
          <Button
            sx={{ margin: "5px 0 20px 0 !important" }}
            className="btn-contained"
            onClick={handleAddCity}
          >
            Add
          </Button>
        </div>
        
        <h2 style={{ marginTop: "30px" }}>Organization Cities</h2>
        <table
          border={1}
          style={{
            borderCollapse: "collapse",
            width: "100%",
            textAlign: "center",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "20px", width: "25%" }}>Sr. No.</th>
              <th style={{ width: "25%" }}>City</th>
            </tr>
          </thead>
          <tbody>
            {cities.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  style={{ padding: "20px", textAlign: "center" }}
                >
                  No cities added yet.
                </td>
              </tr>
            ) : (
              cities.map((item, index) => (
                <tr key={item.cityId}>
                  <td style={{ padding: "20px" }}>{index + 1}</td>
                  <td>{item.name}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ErrorModal open={errorModal} handleClose={() => setErrorModal(false)} msg={errorMsg} />
    </div>
  );
};

export default OrgCity;
